import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import HeaderBar from './HeaderBar';
import TopNavigation from './TopNavigation';
import AppFooter from './AppFooter';
import FloatingChat from '../FloatingChat';

const API = process.env.REACT_APP_BACKEND_URL || '';
const CHAT_CACHE_KEY = 'lexduo_chat_interno_activo';
const CHAT_CACHE_TTL = 5 * 60 * 1000;

// El chat interno se activa/desactiva en Configuracion > Visibilidad de modulos
// del menu. Si esta desactivado no se monta, y asi no hace ningun sondeo.
const leerCacheChat = () => {
  try {
    const raw = sessionStorage.getItem(CHAT_CACHE_KEY);
    if (!raw) return null;
    const { activo, ts } = JSON.parse(raw);
    if (Date.now() - ts > CHAT_CACHE_TTL) return null;
    return activo;
  } catch (e) {
    return null;
  }
};

const MainLayoutNew = ({ children }) => {
  const { user, loading } = useAuth();
  const [chatActivo, setChatActivo] = useState(() => leerCacheChat() === true);

  useEffect(() => {
    if (!user || leerCacheChat() !== null) return;
    const token = localStorage.getItem('lexduo_token');
    if (!token) return;
    axios
      .get(`${API}/api/config/modulos-menu`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const activo = !(res.data?.deshabilitados || []).includes('chat_interno');
        try {
          sessionStorage.setItem(CHAT_CACHE_KEY, JSON.stringify({ activo, ts: Date.now() }));
        } catch (e) { /* noop */ }
        setChatActivo(activo);
      })
      .catch(() => { /* sin dato: el chat no se monta */ });
  }, [user]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <HeaderBar />
      <TopNavigation />
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
      <AppFooter />
      {chatActivo && <FloatingChat />}
    </div>
  );
};

export default MainLayoutNew;
